const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/ReportPage/DocumentReadConfirmation.tsx';
import * as React from 'react';
import { css, cx } from '@emotion/css';
import { theme } from 'App/utils/clientSetupManager';
import { useIntl } from 'react-intl';
import textMap from './translations';
import { Button } from '@mui/material';
import Icon from '@mui/material/Icon';
import { savePDFReadConfirmation } from 'App/actions/documents';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { KISIM_STD_DATE_FORMAT, KISIM_TIME_FORMAT } from '@cistec/common_web/defs/generalDefs';
import { Report } from '@cistec/common_web/defs/kisim';
import { useFeatureFlags } from 'App/store/featureFlags';
import { useMadeSelector } from '@cistec/common_web/utils/store';

import { makeSelectIsLoadingPDFReadConfirmation, usePDFReadConfirmation } from 'App/store/documents';

const buttonStyle = css`
    color ${theme.palette.primary.contrastText};
    background-color: ${theme.palette.primary.main};

    &:disabled {
        color: ${theme.palette.primary.disabled};
    }

    > .txt {
        padding-top: 3px;
    }

    &.confirmed {
        color: ${theme.palette.success.main};
        background-color: transparent;

        &:disabled {
            color: ${theme.palette.success.main};
        }
    }
`;

export interface IProps {
    report: Report;
}

interface IconProps {
    documentReadConfirmed: boolean;
}

const ReadDocumentIcon = (props: IconProps) => {
    return (
        <Icon
            className={cx(props.documentReadConfirmed ? 'icons8-eye-check' : 'icons8-eye-outlined')}
            component="span"
        />
    );
};

export const DocumentReadConfirmation = (props: IProps) => {
    const { formatMessage } = useIntl();
    const dispatch = useDispatch<any>();

    const { data: featureFlags } = useFeatureFlags();

    const { report } = props;

    const { data: documentReadConfirmation } = usePDFReadConfirmation(report.REPORTNR);
    const isDocumentReadConfirmed = !!documentReadConfirmation;

    const isSavingDocumentReadConfirmation = useMadeSelector(
        () => makeSelectIsLoadingPDFReadConfirmation(report.REPORTNR),
        [report.REPORTNR]
    );

    const handleButtonClick = () => {
        const datetimeFormatted = moment(report.DAT, KISIM_TIME_FORMAT).format(KISIM_STD_DATE_FORMAT);
        const fileName = `${report.NAME} ${datetimeFormatted}`;
        const sender = report.SENDER;
        const reportNr = report.REPORTNR;

        dispatch(savePDFReadConfirmation(sender, reportNr, fileName));
    };

    return featureFlags.reports.showDocumentReadConf ? (
        <Button
            variant={isDocumentReadConfirmed ? 'text' : 'contained'}
            size={'small'}
            onClick={handleButtonClick}
            className={cx(buttonStyle, { confirmed: isDocumentReadConfirmed })}
            startIcon={<ReadDocumentIcon documentReadConfirmed={isDocumentReadConfirmed} />}
            disabled={isSavingDocumentReadConfirmation || isDocumentReadConfirmed}
        >
            <span className={'txt'}>
                {isDocumentReadConfirmed ? formatMessage(textMap.read) : formatMessage(textMap.confirmDocumentRead)}
            </span>
        </Button>
    ) : null;
};
